import {spawnErrorToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {QueryKeyName, updateComment} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'
import {PomComment} from '../../types'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const useEditComment = (onSuccess?: () => void) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const plantId = usePlantUpmId()
  const client = useQueryClient()

  return useMutation({
    mutationFn: (comment: PomComment) => updateComment({plantId, comment}),
    onSuccess: () => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetComments]})
      onSuccess?.()
    },
    onError: () => {
      spawnErrorToast(t('comments.updated.error'))
    }
  })
}
